module.exports = __webpack_public_path__ + "static/media/plus-white.66b35cd1.svg";